import { IGeneralLang } from '../../../types/lang'

export const generalLang: IGeneralLang = {
	general: {
		btn_filters_apply: 'Apply',
		react_select_placeholder: 'Select...',
		react_select_no_options: 'No options',
		react_select_create_label: 'Create',
		header_language_label: 'Language',
		total_label: 'Total',
		table_no_data: 'No Data found'
	}
}